import { _ } from "../../../core/polyglot/polyglot.js";
import { formatNoDecimal } from "../../../core/helpers/count-formatting-util.js";
import { month } from "../../../models/period/PeriodType.js";
import { SubColumnSpec } from "../subColumnSpec/SubColumnSpec.js";
import accountRowVisibilityFactory from "../../../models/reports/accountRowVisibilities/accountRowVisibilityFactory.js";
import ActualsPeriodColumnTemplateSource from "../../../models/reports/templates/columnTemplates/periodColumnTemplateSource/ActualsPeriodColumnTemplateSource.js";
import ChangeColumnTemplate from "../../../models/reports/templates/columnTemplates/ChangeColumnTemplate.js";
import ForecastEstimatePeriodColumnTemplateSource from "../../../models/reports/templates/columnTemplates/periodColumnTemplateSource/ForecastEstimatePeriodColumnTemplateSource.js";
import ManualGroupColumnTemplate from "../../../models/reports/templates/columnTemplates/groups/ManualGroupColumnTemplate.js";
import PercentageDeviationType from "../../../models/deviationTypes/PercentageDeviationType.js";
import RelativePeriodTemplate from "../../../models/reports/templates/RelativePeriodTemplate.js";
import RepeatingColumnTemplate from "../../../models/reports/templates/columnTemplates/RepeatingColumnTemplate.js";
import ReportDisplaySettings from "../../../models/reports/reports/ReportDisplaySettings.js";
import ReportTemplate from "../../../models/reports/templates/ReportTemplate.js";
import StaticBudgetPeriodColumnTemplateSource from "../../../models/reports/templates/columnTemplates/periodColumnTemplateSource/StaticBudgetPeriodColumnTemplateSource.js";
import ValueDeviationType from "../../../models/deviationTypes/ValueDeviationType.js";
import YearToDateColumnTemplate from "../../../models/reports/templates/columnTemplates/YearToDateColumnTemplate.js";

/**
 * Todo: Add JSDoc comment
 */
export function makeInitialReportTemplate({ rowTemplates, columnTemplates }) {
	return new ReportTemplate({
		title: _("Comparison Tool"),
		displaySettings: new ReportDisplaySettings({
			accountVisibility:
				accountRowVisibilityFactory.budgetReportVisibility({
					next: accountRowVisibilityFactory.defaultVisibility(),
				}),
			showSummaryRows: false,
			debitPositive: true,
			formatter: formatNoDecimal,
			landscape: false,
			defaultExpansionLevel: 2,
		}),
		rows: rowTemplates,
		columns: columnTemplates,
	});
}

/**
 * Todo: Add JSDoc comment
 */
export function makeActualsSubColumnSpec() {
	return new SubColumnSpec({
		title: _("Actuals"),
		source: new ActualsPeriodColumnTemplateSource(),
	});
}

/**
 * Todo: Add JSDoc comment
 */
export function makePastRepeatingColumnTemplate() {
	return new RepeatingColumnTemplate({
		periodTemplate: new RelativePeriodTemplate({
			periodType: month.getId(),
		}),
		numberOfPeriods: 1,
		step: -1,
	});
}

/**
 * Todo: Add JSDoc comment
 */
export function makeFutureRepeatingColumnTemplate() {
	return new RepeatingColumnTemplate({
		periodTemplate: new RelativePeriodTemplate({
			periodType: month.getId(),
			shift: 1,
		}),
		numberOfPeriods: 0,
		step: 1,
	});
}

/**
 * Todo: Add JSDoc comment
 */
export function makeChangeColumnTemplate({
	title,
	source,
	reportTemplate,
	periodTemplate = new RelativePeriodTemplate(),
}) {
	return new ChangeColumnTemplate({
		customTitle: title,
		hidden: false,
		optional: false,
		visibleWhenNoData: true,
		reportTemplate,
		periodTemplate,
		source,
	});
}

/**
 * Todo: Add JSDoc comment
 */
export function makeForecastEstimateSubColumnSpec(forecastEstimate) {
	return new SubColumnSpec({
		title: forecastEstimate.getName(),
		source: new ForecastEstimatePeriodColumnTemplateSource({
			forecastEstimateId: forecastEstimate.getId(),
		}),
		deviationTypes: [
			new ValueDeviationType(),
			new PercentageDeviationType(),
		],
	});
}

/**
 * Todo: Add JSDoc comment
 */
export function makeBudgetSubColumnSpec(budget) {
	return new SubColumnSpec({
		title: budget.getName(),
		source: new StaticBudgetPeriodColumnTemplateSource({
			budgetId: budget.getId(),
		}),
		deviationTypes: [
			new ValueDeviationType(),
			new PercentageDeviationType(),
		],
	});
}

/**
 * Todo: Add JSDoc comment
 */
export function makeYearToDateGroupColumnTemplate({ period }) {
	return new ManualGroupColumnTemplate({
		title: _("YTD {period}", {
			period: period.getYear().toSmartString(),
		}),
		columnTemplates: [],
	});
}

/**
 * Todo: Add JSDoc comment
 */
export function makeYearToDateColumnTemplate({ title, source }) {
	return new YearToDateColumnTemplate({
		customTitle: title,
		hidden: false,
		optional: true,
		periodTemplate: makeRelativePeriodTemplate({
			periodType: "Year",
		}),
		source,
	});
}

/**
 * Todo: Add JSDoc comment
 */
export function makeSummaryColumnTemplate({
	subColumnSpec,
	reportTemplate,
	periodType,
}) {
	return makeChangeColumnTemplate({
		title: subColumnSpec.getTitle(),
		source: subColumnSpec.getSource(),
		reportTemplate,
		periodTemplate: makeRelativePeriodTemplate({
			periodType: periodType.getId(),
		}),
	});
}

function makeRelativePeriodTemplate({
	periodType,
	shift = 0,
	shiftPeriodType = periodType,
}) {
	return new RelativePeriodTemplate({
		periodType,
		shift,
		shiftPeriodType,
	});
}
